import React, { useState, useEffect } from "react"
import { Button } from "react-bootstrap"

import { PageTitle } from "../../config/AppSettingsConfigProvider"
import ExcelTravelerButton from "../../shared_components/graphing/modals/ExcelTravelerButton"
import PageLoadingPanel from "../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../shared_components/widgets/PageErrorPanel"
import { loadRunDetails } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"
import RunDetailsDiv from "./resources/RunDetailsDiv"
import StartEditRunButton from "./modals/StartRunModal/StartEditRunButton"
import StopRunButton from "./modals/StopRunModal/StopRunButton"

export default function FermManagementRun({ intl, runName = "" }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [run, setRun] = useState({})
  const doLoadPage = () => {
    if (runName) {
      setLoading(true)
      loadRunDetails(runName)
        .then((r) => {
          setRun(r)
          setError(null)
          setLoading(false)
        })
        .catch((err) => {
          console.error(err)
          logToServer(err)
          setError(err)
          setLoading(false)
        })
    }
  }
  useEffect(() => {
    doLoadPage()
  }, [])

  const [showEditRun, setShowEditRun] = useState(false)
  const activityMsg = !run?.id
    ? ""
    : run?.finished_on
      ? intl.formatMessage({ id: "general.complete", defaultMessage: "Complete" })
      : intl.formatMessage({ id: "general.live", defaultMessage: "Live" })
  const runTitle = `${runName}${activityMsg ? ` (${activityMsg})` : ""}`

  return (
    <div className={"full-height"}>
      <div className={"content-block full-height-min"}>
        <PageTitle
          glyph={"list"}
          title={
            <>
              {run?.placeholder && (
                <>
                  <span
                    title={intl.formatMessage({
                      id: "graphing.run.placeholder",
                      defaultMessage: "Placeholder",
                    })}
                    className="fa fa-bookmark-o text-success"
                  />
                  &nbsp;
                </>
              )}
              {runTitle}
            </>
          }
          ExtraElement={() => (
            <Button
              variant={"outline-primary"}
              onClick={(e) => {
                e.preventDefault()
                doLoadPage()
              }}
            >
              <span className={"fa fa-refresh"} />
              &nbsp;
              {intl.formatMessage({ id: "general.refresh", defaultMessage: "Refresh" })}
            </Button>
          )}
        />
        <div>
          {loading ? (
            <PageLoadingPanel />
          ) : error ? (
            <PageErrorPanel attemptReload={doLoadPage} />
          ) : (
            run?.id && (
              <>
                <hr />
                <div style={{ marginBottom: "15px" }}>
                  {run?.id && (
                    <div style={{ alignItems: "center", display: "flex" }}>
                      <StartEditRunButton
                        onBtnClick={() => setShowEditRun(true)}
                        onSuccess={() => {
                          setShowEditRun(false)
                          doLoadPage()
                        }}
                        onHide={() => setShowEditRun(false)}
                        show={showEditRun}
                        isUpdate={true}
                        flexStart={false}
                        disabled={!run?.id}
                        run={run}
                        type={"edit"}
                        btnVariant={"primary"}
                        intl={intl}
                      />
                      &nbsp;&nbsp;
                      <ExcelTravelerButton runData={run} intl={intl} showText={true} isBtn={true} />
                      &nbsp;&nbsp;
                      <a
                        className={"btn-link solid-grey-border"}
                        target={"_blank"}
                        href={`/performance-analysis/?runs=${run.id}`}
                        style={{ padding: "6px 12px", borderRadius: "5px" }}
                      >
                        <span className={"fa fa-area-chart text-success"} />
                        &nbsp;
                        {intl.formatMessage({
                          id: "archiveddash.view.graphs",
                          defaultMessage: "View Graphs",
                        })}
                      </a>
                      &nbsp;&nbsp;
                      <StopRunButton
                        run={run}
                        intl={intl}
                        onSuccess={doLoadPage}
                        extraSm={false}
                        flexStart={false}
                        linkRunName={false}
                      />
                    </div>
                  )}
                  <hr />
                </div>
                <RunDetailsDiv selectedRun={run} linkRunName={false} intl={intl} />
              </>
            )
          )}
        </div>
      </div>
    </div>
  )
}
